import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { CartLineModel, OrderLineModel, ProductDto, ProductModel } from "@insite/client-framework/Types/ApiModels";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps {
    product: ProductModel;
    productDto: ProductDto | null;
    extendedStyles?: ProductDescriptionStyles;
}

type Props = OwnProps;

export interface ProductDescriptionStyles {
    productDetailLink?: LinkPresentationProps;
    productDetailDescription?: TypographyProps;
    productNumberLink?: LinkPresentationProps;
}

export const productDescriptionStyles: ProductDescriptionStyles = {
    productDetailLink: {
        css: css``,
        typographyProps: {
            css: css`
                ${wrapInContainerStyles}
            `,
        },
    },
    productNumberLink: {
        css: css``,
        typographyProps: {
            color: "secondary",
            css: css`
                margin-bottom: 0;
                ${wrapInContainerStyles}
            `,
        },
    },
    productDetailDescription: {
        color: "primary",
        css: css`
            ${wrapInContainerStyles}
        `,
    },
};

const MiniCartProductDescription: FC<Props> = ({ product, productDto, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(productDescriptionStyles, extendedStyles));

    const description = product.productTitle ? product.productTitle : productDto?.shortDescription;
    const productNumber = product.productNumber ? product.productNumber : productDto?.erpNumber;

    return (
        <div>
            <Link {...styles.productNumberLink} href={product.canonicalUrl} data-test-selector="productNumberLink">
                <Typography
                    variant="p"
                    weight="bold"
                    data-test-selector="cdtMiniProductNumberTypography"
                    {...styles.productNumberLink?.typographyProps}
                >
                    {productNumber}
                </Typography>
            </Link>
            <Typography variant="p" data-test-selector="cdtMiniProductDescription" {...styles.productDetailDescription}>
                {description}
            </Typography>
        </div>
    );
};

export default MiniCartProductDescription;
